/**
 * Cliente API – llama al Cloudflare Worker desde React.
 * En desarrollo apunta a http://localhost:8787 (wrangler dev).
 * En producción apunta al mismo dominio (Pages + Worker integrado).
 */

const BASE_URL =
  import.meta.env.DEV
    ? 'http://localhost:8787'
    : ''   // mismo origen en Cloudflare Pages

async function request(path, options = {}) {
  const res = await fetch(`${BASE_URL}${path}`, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  })

  const data = await res.json()

  if (!res.ok) {
    const message = data?.error ?? `HTTP ${res.status}`
    throw new Error(message)
  }

  return data
}

// ── Items ─────────────────────────────────────────────────────────────────────

export const api = {
  items: {
    list:   ()           => request('/api/items'),
    get:    (id)         => request(`/api/items/${id}`),
    create: (body)       => request('/api/items', { method: 'POST',   body: JSON.stringify(body) }),
    update: (id, body)   => request(`/api/items/${id}`, { method: 'PUT',    body: JSON.stringify(body) }),
    remove: (id)         => request(`/api/items/${id}`, { method: 'DELETE' }),
  },
}
